module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg",
      "footer": false,
      "headerStyle": {
        'background-color': _vm.currentIntegration.color.main
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("GetYourGuide")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('top-area', {
    attrs: {
      "integration": _vm.currentIntegration
    }
  }, [_c('div', {
    staticClass: "bg-blue-pale p-2 mt-3"
  }, [_vm._v("\n                Please note that you need to have active products on GYG in order to connect with Pluralo. Log into your "), _c('a', {
    staticClass: "darkest underlined",
    attrs: {
      "href": "https://supplier.getyourguide.com/",
      "target": "_blank"
    }
  }, [_vm._v("Supply Portal")]), _vm._v(".  Don’t have an account? "), _c('a', {
    staticClass: "darkest underlined",
    attrs: {
      "href": "https://supplier.getyourguide.com/en/register",
      "target": "_blank"
    }
  }, [_vm._v("Sign Up here")]), _vm._v(".\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 pt-4 pb-4"
  }, [_c('div', [_c('div', {
    staticClass: "d-flex stepRow"
  }, [_c('div', {
    staticClass: "stepNumber d-flex border-dark align-items-center justify-content-center"
  }, [_vm._v("1")]), _vm._v(" "), _c('div', {
    staticClass: "stepText d-flex align-items-center flex-grow-1"
  }, [_c('div', [_vm._v("\n                            Set your commissions and payment protocol with GetYourGuide.\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "stepButton d-flex"
  }, [(_vm.creatingProtocol) ? _c('loader') : (!_vm.isIntegrated) ? _c('button', {
    staticClass: "btn tertiary w-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.crateProtocol()
      }
    }
  }, [_vm._v("Create Protocol")]) : (_vm.isIntegrated) ? _c('button', {
    staticClass: "btn tertiary w-100",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fas fa-check color-3"
  }), _vm._v(" Created")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-flex stepRow"
  }, [_c('div', {
    staticClass: "stepNumber d-flex border-dark align-items-center justify-content-center"
  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
    staticClass: "stepText d-flex align-items-center flex-grow-1"
  }, [_c('div', [_vm._v("\n                            Log into your "), _c('a', {
    staticClass: "color-1 underlined bold",
    attrs: {
      "href": "https://supplier.getyourguide.com/",
      "target": "_blank"
    }
  }, [_vm._v("Supply Portal")]), _vm._v(" and using the table bellow connect the products ID."), _c('br')])])])]), _vm._v(" "), _c('div', {
    staticClass: "productListHolder mb-3"
  }, [(_vm.getLoadingProducts) ? _c('div', {
    staticClass: "p-4 text-center"
  }, [_c('loader')], 1) : _c('div', [_c('list', {
    attrs: {
      "header": _vm.productListHeader,
      "body": _vm.productListBody,
      "rows": _vm.products
    }
  })], 1)]), _vm._v(" "), _c('bottom-area', {
    attrs: {
      "isIntegrated": _vm.isIntegrated,
      "showSaveBtn": false
    },
    on: {
      "disableIntegration": function($event) {
        return _vm.deactivateIntegration()
      },
      "close": function($event) {
        return _vm.closeModal()
      }
    }
  }, [(_vm.isIntegrated) ? _c('button', {
    staticClass: "btn blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openAgentDetails()
      }
    }
  }, [_vm._v("Open GYG Agent Details")]) : _vm._e()])], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-b47ed294", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b47ed294"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/integrations/integratePopup/gygIntegrate.vue
// module id = 3216
// module chunks = 0